const common = {
  siteName: 'Reserve Connect Urubici',
  tagline: 'Lodging in Serra Catarinense',
  loading: 'Loading...',
  error: 'Error loading',
  retry: 'Try again',
  back: 'Back',
  search: 'Search',
  filter: 'Filter',
  bookNow: 'Book Now',
  contactUs: 'Contact Us',
  whatsapp: 'WhatsApp',
  phone: 'Phone',
  email: 'Email',
  navigation: {
    home: 'Home',
    lodging: 'Lodging',
    restaurants: 'Restaurants',
    experiences: 'Experiences',
    events: 'Events',
    cityGuide: 'Where to Go',
    about: 'About',
    contact: 'Contact',
    groups: 'Groups & Agencies',
    terms: 'Terms of Use',
    privacy: 'Privacy Policy',
    cookies: 'Cookie Policy',
    cancellation: 'Cancellation & Refund',
    login: 'Login',
    centralReservas: 'Reservations Center',
    announcers: 'For Advertisers',
  },
  header: {
    language: 'Language:',
    menuAriaLabel: 'Open menu',
  },
  footer: {
    brand: 'Reserve Connect',
    institutional: 'Institutional',
    services: 'Services',
    legal: 'Legal',
    rights: 'All rights reserved.',
    description: 'Integrated reservation platform connecting tourists to the best hotels and local experiences.',
    whatsappContact: 'Contact the Reservations Center on WhatsApp',
    whatsappMessage: 'Hello! I would like help with a reservation.',
    poweredBy: 'Powered by Readdy',
    links: {
      aboutUs: 'About Reserve Connect',
      forHotels: 'For Hotels',
      municipalIntegration: 'Municipal Integration',
      cityPortal: 'City Portal',
      hotels: 'Hotels',
      support: 'Support',
      faq: 'FAQ',
    },
  },
  aria: {
    previousSlide: 'Previous slide',
    nextSlide: 'Next slide',
    goToSlide: 'Go to slide {{number}}',
    switchLanguage: 'Switch language to {{lang}}',
  },
};
export default common;
